<div *ngIf="loading">
  <app-loader></app-loader>
</div>

<div class="em-c-well" *ngIf="!loading">
  <!-- Description -->
  <p class="description">
    By subscribing to this service, you will receive email notifications
    whenever your Raw Material Plans are (i) Published to IDP, and (ii) when
    plans are ingested by your corresponding supplier(s)
  </p>

  <!-- Email section -->
  <div class="email-section">
    <label class="em-c-field__label">Email Address</label>
    <p>{{ user.email }}</p>
  </div>

  <!-- Subscribe to notification -->
  <form (ngSubmit)="onSubmit()" class="form">
    <label class="em-c-field__label">
      Subscribe to email notification for:
    </label>

    <div class="subscribe-section" *ngFor="let event of events">
      <div class="subscribe-section-label">
        <label class="em-c-field__label">
          {{ eventSubscriptions[event].label }}:
        </label>
      </div>
      <div class="radio-item">
        <input
          type="radio"
          [name]="event"
          [(ngModel)]="eventSubscriptions[event].subscribed"
          [value]="true"
        />
        <span>Subscibe</span>
      </div>
      <div class="radio-item">
        <input
          type="radio"
          [name]="event"
          [(ngModel)]="eventSubscriptions[event].subscribed"
          [value]="false"
        />
        <span>Unsubscibe</span>
      </div>
    </div>

    <!-- Buttons -->
    <div class="btn-group">
      <app-custom-btn
        text="Cancel"
        color="secondary"
        type="button"
        (handleClick)="cancelClick()"
      >
      </app-custom-btn>
      <app-custom-btn
        text="Submit"
        color="primary"
        type="submit"
        [ngStyle]="{ 'margin-right': '10px' }"
      >
      </app-custom-btn>
    </div>
  </form>
</div>
